//登録済みお気に入りを削除
import deleteBookmarkFunc from './deleteBookmarkFunc';

export default function () {
	const siteurl = document.getElementById('js-page-wrapper').getAttribute('data-siteurl');
	const putEl = document.getElementById('js-bookmark');

	putEl.addEventListener('bookmarkReady', function() {

		const options = document.querySelectorAll('.js-bookmark-option');
		[].forEach.call(options, (option) => {
			option.onclick = function(e) {
				const item = e.currentTarget.closest('.js-item');
				item.classList.add('is-show-option');
			}
		});

		const deleteBtns = document.querySelectorAll('.js-bookmark-delete');
		[].forEach.call(deleteBtns, (btn) => {
			btn.onclick = function(e) {
				const el = e.currentTarget;
				const recipeDeleteId = el.value;
				el.querySelector('.c-icon--trash').classList.add('is-loading');

				axios({
					method: 'get',
					url: siteurl + '/samereciipeapi/',
					responseType:'document',
					params: {
						orgid: recipeDeleteId
					},
				})
				.then(function (response) {
					const items = response.data.querySelectorAll('#samerecipe-list li');
					//同じお気に入りボタンを共有するレシピがあればそちらも削除（ボタンの塗り用）
					deleteBookmarkFunc(items, recipeDeleteId, recipeDeleteId);
					const item = el.closest('.js-item');
					item.style.height = item.offsetHeight + 'px';
					setTimeout(() => {
						item.classList.add('is-remove');
					}, 100);

				})
				.catch(function (error) {
					console.log(error);
				});
			}
		});

		function hideDeleteBtn(e) {
			const el = e.currentTarget;
			const item = el.closest('.js-item');
			if(item.classList.contains('is-show-option')) {
				e.preventDefault();
				item.classList.remove('is-show-option')
			}
		}

		const links = document.querySelectorAll('.js-link');
		[].forEach.call(links, (link) => {
			link.onclick = (e) => {
				hideDeleteBtn(e);
			}
			link.ontouchmove = (e) => {
				hideDeleteBtn(e);
			}
		});

	});
}
